import React, { useContext } from 'react';
import UserContext from '../UserContext';
import { Avatar, Box, Chip, Typography } from '@mui/material';
import { DetailRow, PageContainer, PageHeader, Section } from '../components/Page';
import { hasFeature, isBillingAdmin } from '../business/Subscription';
import { Link as RouterLink } from 'react-router';
import { Link } from '@mui/material';

export function getInitials(givenName?: string, familyName?: string) {
  return `${(givenName || '').trim().charAt(0)}${(familyName || '').trim().charAt(0)}`.toUpperCase() || '?';
}

export default function UserSettingsPage() {
  const userContext = useContext(UserContext);
  const user = userContext?.user;

  if (!user) {
    return null;
  }

  const fullName = `${user.givenName || ''} ${user.familyName || ''}`.trim();

  return (
    <PageContainer maxWidth={760}>
      <PageHeader title="User Settings" description="Your profile details come from your Xero account. To change them, update your Xero profile." />

      <Section title="Profile">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Avatar sx={{ bgcolor: '#007ca3', width: 48, height: 48 }}>{getInitials(user.givenName, user.familyName)}</Avatar>
          <Box>
            <Typography sx={{ fontWeight: 600 }}>{fullName || user.email}</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </Box>
          {isBillingAdmin(user) && <Chip size="small" label="Billing admin" variant="outlined" sx={{ ml: 'auto' }} />}
        </Box>
        <DetailRow
          label="Firm"
          value={
            user.firm && isBillingAdmin(user) && hasFeature(user, 'MultiUser') ? (
              <Link component={RouterLink} to="/firm">
                {user.firm.name}
              </Link>
            ) : (
              user.firm?.name || 'Not part of a firm'
            )
          }
        />
        <DetailRow
          label="Xero user ID"
          value={<Typography sx={{ fontFamily: 'monospace', fontSize: '0.8rem', color: 'text.secondary' }}>{user.xeroUserId}</Typography>}
        />
      </Section>
    </PageContainer>
  );
}
